import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 6.133c0-2.167 2.39-3.483 4.221-2.323l9.262 5.866c1.705 1.08 1.705 3.567 0 4.647l-9.262 5.866c-1.83 1.16-4.221-.156-4.221-2.324zm3.419-1.056A1.25 1.25 0 0 0 6.25 6.133v11.732a1.25 1.25 0 0 0 1.919 1.056l9.262-5.866a1.25 1.25 0 0 0 0-2.112z",
    clipRule: "evenodd"
  }));
}
var IcPlay = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPlay));

export { IcPlay as I };
